import React from "react";
import { Avatar, Typography, Box, Chip } from "@mui/material";
import MaleIcon from "@mui/icons-material/Male";
import FemaleIcon from "@mui/icons-material/Female";
import StoreIcon from "@mui/icons-material/Store";
import { useNavigate } from "react-router-dom";
import { capitalizeFirstLetter } from "../../utils/Utils";

const plans = ["Gold", "Diamond Special", "Diamond", "Platinum"];

const ListingTableHeadings = ["", "Name", "Category", "Year", "Price", "Status", "Store", "Gender"];

const ListView = ({ classes, listData }) => {
  const navigate = useNavigate();

  const findCategoryName = (id) => {
    const cat = classes?.find((c) => c.id === parseInt(id));
    return cat?.name || "N/A";
  };

  const formatDate = (d) => new Date(d).getUTCFullYear();

  if (!listData?.length) {
    return (
      <Typography textAlign="center" sx={{ color: "#555", py: 6 }}>
        No listings found.
      </Typography>
    );
  }

  return (
    <Box sx={{ overflowX: "auto" }}>
      {/* Header row */}
      <Box
        sx={{
          display: "grid",
          gridTemplateColumns: "48px 1.5fr 1fr 60px 80px 80px 1fr 60px",
          gap: 1,
          px: 2,
          py: 1,
          backgroundColor: "#1a1a1a",
          borderRadius: "10px 10px 0 0",
          border: "1px solid #2a2a2a",
          borderBottom: "none",
        }}
      >
        {ListingTableHeadings.map((h, i) => (
          <Typography key={i} sx={{ color: "#666", fontSize: "12px", fontWeight: 700, textAlign: i > 0 ? "center" : "left", textTransform: "uppercase", letterSpacing: "0.5px" }}>
            {h}
          </Typography>
        ))}
      </Box>

      {/* Rows */}
      <Box sx={{ display: "flex", flexDirection: "column", gap: "2px", border: "1px solid #2a2a2a", borderTop: "none", borderRadius: "0 0 10px 10px", overflow: "hidden" }}>
        {listData.map((data) => (
          <Box
            key={data.id}
            onClick={() => navigate("/listing/" + data?.id)}
            sx={{
              display: "grid",
              gridTemplateColumns: "48px 1.5fr 1fr 60px 80px 80px 1fr 60px",
              gap: 1,
              alignItems: "center",
              px: 2,
              py: 1.2,
              backgroundColor: "#151515",
              cursor: "pointer",
              transition: "all 0.2s ease",
              "&:hover": { backgroundColor: "#1e1e1e", "& .row-name": { color: "#FFC001" } },
            }}
          >
            <Avatar src={data.media?.[0]?.url} alt={data.name} sx={{ width: 40, height: 40, border: "1px solid #2a2a2a" }} />

            <Typography className="row-name" noWrap sx={{ color: "#fff", fontSize: "14px", fontWeight: 600, transition: "color 0.2s" }}>
              {data.name}
            </Typography>

            <Typography noWrap sx={{ color: "#777", fontSize: "13px", textAlign: "center" }}>
              {findCategoryName(data.category_id)}
            </Typography>

            <Typography sx={{ color: "#555", fontSize: "13px", textAlign: "center" }}>
              {formatDate(data.created_at)}
            </Typography>

            <Typography sx={{ color: "#FFC001", fontWeight: 700, fontSize: "14px", textAlign: "center" }}>
              ${data.price}
            </Typography>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {data.on_hold ? (
                <Chip label="HOLD" size="small" sx={{ backgroundColor: "#FFD300", color: "#000", fontWeight: 700, fontSize: "10px", height: "20px" }} />
              ) : data.status === "nfs" ? (
                <Chip label="NFS" size="small" sx={{ backgroundColor: "#333", color: "#aaa", fontWeight: 700, fontSize: "10px", height: "20px" }} />
              ) : data.status === "sold" ? (
                <Chip label="SOLD" size="small" sx={{ backgroundColor: "#EF0107", color: "#fff", fontWeight: 700, fontSize: "10px", height: "20px" }} />
              ) : (
                <Chip label="AVAIL" size="small" sx={{ backgroundColor: "rgba(0,180,100,0.15)", color: "#00b464", fontWeight: 700, fontSize: "10px", height: "20px" }} />
              )}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {plans.includes(data?.seller?.user?.subscriptions?.[0]?.plan?.name) ? (
                <Box
                  onClick={(e) => { e.stopPropagation(); navigate("/neighbour/" + data?.seller?.store?.id); }}
                  sx={{ display: "flex", alignItems: "center", gap: 0.5, "&:hover": { "& *": { color: "#FFC001" } } }}
                >
                  <StoreIcon sx={{ color: "#555", fontSize: 14 }} />
                  <Typography noWrap sx={{ color: "#666", fontSize: "12px" }}>{data?.seller?.store?.brand_name}</Typography>
                </Box>
              ) : <Typography sx={{ color: "#333", fontSize: "12px" }}>—</Typography>}
            </Box>

            <Box sx={{ display: "flex", justifyContent: "center" }}>
              {data.sex === "male" ? (
                <MaleIcon sx={{ color: "#4da6ff", fontSize: 18 }} />
              ) : data.sex === "female" ? (
                <FemaleIcon sx={{ color: "#ff69b4", fontSize: 18 }} />
              ) : (
                <Box sx={{ display: "flex" }}>
                  <MaleIcon sx={{ color: "#4da6ff", fontSize: 15 }} />
                  <FemaleIcon sx={{ color: "#ff69b4", fontSize: 15 }} />
                </Box>
              )}
            </Box>
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default ListView;
